import type { AddressPayload } from '~~/layers/base/stores/contact.store'
import type { CheckoutCartAddress } from '~~/layers/base/types/checkout'

/**
 * Maps ACCS/Stripe `CheckoutCartAddress` to profile `AddressPayload` for `POST /api/addresses`.
 * Checkout Stripe saves use that route (dedupe + default on create), then
 * `POST /api/checkout/sync-return-address` to push shipping onto the cart.
 */
export function mapCheckoutCartAddressToAddressPayload(
    cartAddress: CheckoutCartAddress
): AddressPayload {
    const street = cartAddress.street ?? []
    return {
        first_name: cartAddress.firstname?.trim() || null,
        last_name: cartAddress.lastname?.trim() || null,
        street_address_1: street[0]?.trim() || null,
        street_address_2: street[1]?.trim() || null,
        city: cartAddress.city?.trim() || null,
        state: cartAddress.region?.trim() || null,
        zip_code: cartAddress.postcode?.trim() || null,
        country: cartAddress.country_code?.trim() || null,
        country_code: cartAddress.country_code?.trim() || null,
    }
}
